// extracted by mini-css-extract-plugin
module.exports = {"header":"TenantData_header__14KAO","listItem":"TenantData_listItem__2hxT1","icon":"TenantData_icon__QT-TD"};